import React from 'react'
import styled from 'styled-components'

import Modal from '../Modal'
import Button from '../../components/Button'
import { flexBoxStyles } from '../../components/Flexbox'

const ReportErrorModal = ({ onClose, isOpen, id, message, onReset }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title={<ModalTitle>Wystąpił błąd podczas próby eksportu do csv.</ModalTitle>}
  >
    <P>{message}</P>
    <Footer justify="space-between">
      <Button label="Wygeneruj raport ponownie" onClick={onReset} />
      <Button color="white" label="Zamknij" marginLeft onClick={onClose} />
    </Footer>
  </Modal>
)

export const ReportGenerateModal = ({ onClose, isOpen }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title={<ModalTitle>Zlecenie Wygenerowania raportu zostało przyjęte.</ModalTitle>}
  >
    <Footer justify="space-between">
      <Button label="OK" marginLeft onClick={onClose} />
    </Footer>
  </Modal>
)

const ModalTitle = styled.span`
  font-weight: 400;
  margin-bottom: 40px;
  display: block;
`
const P = styled.p`
  padding-bottom: 10px;
`

const Footer = styled.div`
  ${flexBoxStyles};
  &::before {
    position: absolute;
    left: 0;
    bottom: 7rem;
    content: '';
    border-bottom: 1px solid #eee;
    width: 100%;
  }
`

export default ReportErrorModal
